export default "__VITE_ASSET__DioXV5P8__"